import React, { useState } from "react";
import styles from "./NewWorkspace.module.css";
import ModalBlackBgTemplate from "../ModalBlackBgTemplate/ModalBlackBgTemplate";
import HeaderCard from "../HeaderCard/HeaderCard";
import Button from "../Button/Button";
import { ReactComponent as WorkspaceIcon } from "../../assets/WorkspaceIcon.svg";
import { useTranslation } from "react-i18next";
import WorkspaceSection from "./WorkspaceSection/WorkspaceSection";
import TeamWorkspaceSection from "./TeamWorkspaceSection/TeamWorkspaceSection";

const NewWorkspace = ({ setShowWorkspace,setShowInviteToWorkspace }) => {
  const [t] = useTranslation("accountSetting");
  const [selectedOption, setSelectedOption] = useState(0);

  const close = () => {
    setShowWorkspace(false);
  };

  return (
    <div>
      <ModalBlackBgTemplate
        close={close}
        customStyle={{
            maxWidth: '700px',
            width: '100vw',
            height: '80vh',
            minHeight: '80vh',
        }}
      >
        <HeaderCard
          title={`${t('worskpace')} 1`}
          setState={setShowWorkspace}
          titleStyle={{ fontSize: " clamp(9px, 1.5vw, 18px)" }}
        >
          <Button type="white">{t("cancel")}</Button>
          {selectedOption === 0 ?<Button type="green">{t("save")}</Button> :<Button type="green" action={() => setShowInviteToWorkspace(true)}>{t("invite")}</Button> }
        </HeaderCard>

        <div className={styles.worskpaceSettings}>
          <div className={styles.leftWorkspaceSetting}>
            <ul>
              <li
                className={`${selectedOption === 0 ? styles.selected : ""}`}
                onClick={() => setSelectedOption(0)}
              >
                <WorkspaceIcon />
                {t("worskpace")}
              </li>
              <li
                className={`${selectedOption === 1 ? styles.selected : ""}`}
                onClick={() => setSelectedOption(1)}
              >
                <WorkspaceIcon />
                {t("team")}
              </li>
            </ul>
          </div>

          <div className={styles.rightWorkspaceSetting}>
            {selectedOption == 0 ? (
                <WorkspaceSection setSelectedOption={setSelectedOption}/>
            ) : (
                <TeamWorkspaceSection/>
            )}
          </div>
        </div>
      </ModalBlackBgTemplate>
    </div>
  );
};

export default NewWorkspace;
